<template>
  <div id="cms-page">
    <header class="bg-cl-secondary py35 pl20">
      <div class="container">
        <div class="row middle-sm">
          <h1 class="col-sm-9 category-title mb10">
            {{ cmsPageContent.title }}
          </h1>
        </div>
      </div>
    </header>
    <div class="container pb60 cms-box" v-html="cmsPageContent.content" @click="onContentClick" />
  </div>
</template>

<script>
import CmsPage from '@vue-storefront/core/pages/CmsPage'
import { isServer } from '@vue-storefront/core/helpers'

export default {
  computed: {
    cmsPageContent () {
      return this.$store.state.cmsPage.current
    }
  },
  mixins: [CmsPage],
  methods: {
    onContentClick (event) {
      const consentLink = event.target && event.target.closest ? event.target.closest('.change-consent') : null
      if (!consentLink) {
        return
      }
      event.preventDefault()
      if (typeof window.__tcfapi !== 'function') {
        return
      }
      try {
        window.__tcfapi('displayConsentUi', 2, () => {})
      } catch (e) {
        // okno zgód niedostępne — kliknięcie bez efektu
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (isServer) {
      next()
    } else {
      next(vm => {
        vm.$store.commit('ui/routeChanged', { to: to, from: from })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.category-title {
  @media (max-width: 767px) {
    font-size: 28px;
  }
}
.cms-box {
  @media (max-width: 767px) {
    text-align: justify;
  }
  /deep/ .change-consent {
    cursor: pointer;
  }
}
</style>
